import "@tento-ui/init";
import { LonaBrandApp } from "../lib/brand-app/lona-brand-app";

// `?test=…` toggles the static mock blog dataset: set (or clear, for
// `?test=0|off|false`) the `lona_blog_mock` cookie that the data API reads
// server-side, then reload without the query param so the page boots cleanly
// with the cookie in effect. Returns true when a reload was triggered.
function applyBlogTestParam(): boolean {
  const params = new URLSearchParams(window.location.search);
  if (!params.has("test")) return false;

  const value = (params.get("test") ?? "").trim().toLowerCase();
  const disable = value === "0" || value === "off" || value === "false";
  document.cookie = disable
    ? "lona_blog_mock=; path=/; max-age=0"
    : "lona_blog_mock=1; path=/";

  params.delete("test");
  const search = params.toString();
  const next = `${window.location.pathname}${search ? `?${search}` : ""}${window.location.hash}`;
  window.location.replace(next);
  return true;
}

if (!applyBlogTestParam()) {
  const app = new LonaBrandApp();
  await app.init();
}
